import addDays from 'date-fns/addDays';
import format from 'date-fns/format';

export type Forecast = {
    time: string;
    skyIcon: string;
    precipitation: number;
};

export type ShownForecast = {
    label: string;
    isSunny: boolean;
    precipitation: number;
};

const sunnySymbols = ['clearsky', 'fair'];

function isSunny(skyIcon: string): boolean {
    const symbol = skyIcon.split('/').pop() || '';
    return sunnySymbols.some((sunnySymbol) => symbol.startsWith(sunnySymbol));
}

export function forecastsForTheDay(forecasts: Forecast[], bookingDate: Date): ShownForecast[] {
    const day = format(bookingDate, 'yyyy-MM-dd');
    const nextDay = format(addDays(bookingDate, 1), 'yyyy-MM-dd');
    const wanted = [
        { date: day, hour: '06', label: '06:00' },
        { date: day, hour: '12', label: '12:00' },
        { date: day, hour: '18', label: '18:00' },
        { date: nextDay, hour: '00', label: '24:00' }
    ];

    return wanted.flatMap(({ date, hour, label }) => {
        const found = forecasts.find(
            (forecast) =>
                forecast.time.slice(0, 10) === date && forecast.time.slice(11, 13) === hour
        );
        return found
            ? [{ label, isSunny: isSunny(found.skyIcon), precipitation: found.precipitation }]
            : [];
    });
}
